import Card from '../Card';

const shimmerToneClass = 'bg-border/80 dark:bg-muted-foreground/20 animate-pulse rounded';

const ShimmerBar = ({ className }: { className?: string }) => (
  <div className={`${shimmerToneClass} ${className}`} />
);

const ShimmerMetric = ({ textWidthClass }: { textWidthClass: string }) => (
  <ShimmerBar className={`h-[1.6rem] ${textWidthClass}`} />
);


function TotalBalanceCardSkeleton() {
  return (
    <Card>
      <div className="p-4">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center text-muted-foreground font-semibold">
            <div className={`w-6 h-6 rounded-full mr-2 ${shimmerToneClass}`}></div>
            <ShimmerBar className="w-24 h-5" />
          </div>
        </div>

        <div className="flex justify-between items-center mb-4 gap-2">
          <ShimmerBar className="h-9 w-40 max-w-full" />
          <ShimmerBar className="w-[60px] h-6 flex-shrink-0" />
        </div>

        <div className="flex flex-wrap flex-row gap-2">
          <ShimmerMetric textWidthClass="w-[7.6rem] rounded-full" />
          <ShimmerMetric textWidthClass="w-[5.5rem] rounded-full" />
        </div>
      </div>
    </Card>
  );
}

export default TotalBalanceCardSkeleton; 
